import { warningMessageForRequiredField_0 } from '../strings.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { CardMode } from 'txp-data/lib/schema/viewSchema/CardMode';
import { MAX_TITLE_LENGTH } from '../helpers/EditableCardConsts';

import isInputTextValid from '../utils/view/isInputTextValid';
import TxpDataRow from 'txp-data/lib/schema/viewSchema/TxpDataRow';
import { isBrowserEdge } from 'owa-user-agent/lib/userAgent';
import { dataRows } from './dataRows';
import setCursorPositionToStart from '../utils/view/setCursorPositionToStart';

let classNames = require('classnames');
let style = require('./Txp.scss');

export interface SummaryEditProps {
    cardMode: CardMode;
    readOnlyLines: TxpDataRow[];
    editableField: string;
    editableData: TxpDataRow;
    onTextChanged?: (value: string) => void;
}

const SummaryEdit = (props: SummaryEditProps) => {
    let { readOnlyLines, editableField, cardMode, editableData } = props;
    let { placeholder, isRequired } = editableData;

    let editableValue: string = editableField;
    let summaryEditLines = readOnlyLines.map((txpDataRow, index) => {
        if (txpDataRow) {
            return dataRows(index, style, txpDataRow.text);
        } else {
            return null;
        }
    });

    const validateText = (value: string): string => {
        if (!isInputTextValid(value, isRequired)) {
            return loc(warningMessageForRequiredField_0);
        }
        return '';
    };

    const onValueChanged = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        value: string
    ) => {
        let { onTextChanged } = props;
        editableValue = value;
        if (onTextChanged) {
            onTextChanged(value);
        }
    };

    return (
        <div className={classNames(style.cardSummaryEditLines, 'allowTextSelection')}>
            <div className={isBrowserEdge() ? style.summaryEditLabelEdge : style.summaryEditLabel}>
                <TextField
                    required={isRequired}
                    onChange={onValueChanged}
                    borderless={true}
                    value={editableValue ? editableValue : ''}
                    autoFocus={true}
                    placeholder={placeholder}
                    underlined={true}
                    maxLength={MAX_TITLE_LENGTH}
                    readOnly={cardMode == CardMode.Process}
                    onGetErrorMessage={validateText}
                    componentRef={cardMode === CardMode.Process ? setCursorPositionToStart : null}
                />
            </div>
            <div className={style.summaryEditReadOnlyLines}>{summaryEditLines}</div>
        </div>
    );
};

export default SummaryEdit;
